<template>
  <div class="page-with-top-bar">
    <project-template-admin-quick-buttons hiddenOption="manage-statuses"/>
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="map-marker-alt"></b-icon>
              <span> {{ $t('statuses_list') }} </span>
            </template>
            <div>
              <project-statuses-manual
                ref="project_locations_manual"
                :project-id="projectId"
                :is-admin-locations="true"
                :entity-type="'project_templates'"
              />
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProjectStatusesManual from '../../../components/project-statuses-manual'
  import ProjectTemplateAdminQuickButtons from '../../../components/project-template-admin-quick-buttons.vue'

  export default {
    middleware: 'auth',
    title: 'manage_statuses_page_title',
    menuOption: '0-6',

    components: {
      ProjectStatusesManual,
      ProjectTemplateAdminQuickButtons
    },

    data: () => ({
      mainActiveTab: 0,
    }),

    computed: {
      ...mapGetters({
        project: "template/project"
      }),

      projectId() {
        return parseInt(this.$route.params.template_id);
      }

    },

    watch: {
      mainActiveTab(value) {
        if (value == 0) {
          this.$refs.project_locations_manual.reload()
        }
      }
    },

    created() {
      let projectName = this.project.name
        ? this.project.name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];
    },

    methods: {}
  };
</script>
